const services = [
  {
    id: 1,
    heading: "Building & Construction",
    p: "Our services include design, planning, site preparation, and structural components. Related services also cover project management, renovation, procurement of materials, and the ongoing maintenance of installed systems to ensure a building iss safe, comfortable, and efficient.",
  },
  {
    id: 2,
    heading: "Consultancy Services",
    p: "Our services encompass a wide range, from early-stage feasibility studies and design coordination to on-site construction management, quality assurance, and dispute resolution. We provide expert advice and management for project planning, budgeting, scheduling, procurement, safety, and regulatory compliance to ensure projects stay on time, within budget, and meet quality standards.",
  },
  {
    id: 3,
    heading: "Project Management",
    p: "We provide services such as planning and scheduling, budgeting and cost control, procurement management, quality assurance, risk management, contract administration, site safety management, and progress reporting to ensure a project is completed on time, within budget, and to the client's satisfaction. These services encompass the entire project lifecycle, from inception and design through construction and final closeout.",
  },
  {
    id: 4,
    heading: "Real Estate",
    p: "We provide a wide range of services, including marketing and leasing, tenant screening and relations, rent collection and financial management, property maintenance and repairs, and legal and administrative compliance. We handle the daily operations of a property, from ensuring it's rent-ready and marketable to collecting payments, managing budgets, overseeing maintenance, and resolving tenant issues on behalf of owners",
  },
];

export default services;
